<template>
    <div>
        <div class="col-12 form-row pl-0" v-for="author in authors">
            <div class="col-1 form-group mb-1">
                <input type="number" class="form-control" :value="author.order" name="author[order][]" />
            </div>
            <div class="col-7 form-group mb-1">
                <author-select :selected="author.author"></author-select>
            </div>
            <div class="col-4 form-group mb-1">
                <select name="author[role][]" class="form-control">
                    <option :selected="role.id == author.role" v-for="role in roles" :value="role.id" v-text="role.name"></option>
                </select>
            </div>
        </div>
        <div class="col-12 pl-0">
            <a class="mt0 btn btn-success small primary" target="_blank" @click="addAuthor()">
                <i class="fa fa-plus"></i>
            </a>
        </div>
    </div>
</template>

<script>
import AuthorSelect from "./AuthorSelect.vue";

export default {
    name: "AuthorList",
    components: {AuthorSelect},
    props: {
        currentAuthors: {
            required: false,
            type: Array,
        },
        roles: {
            required: false,
            type: Array,
        }
    },
    data() {
        return {
            authors: [],
            nextOrder: 1,
        }
    },
    methods: {
        addAuthor() {
            this.authors.push({
                author: "",
                role: "",
                order: this.nextOrder,
            });
            this.nextOrder++;
        },
        removeAuthor(index) {
            this.authors.splice(index, 1);
        }
    },
    created() {
        if(this.currentAuthors.length){
            let vue = this;
            _.forEach(this.currentAuthors, function(author, i){
                vue.authors.push(author);
                vue.nextOrder++;
            });
        }
        else{
            this.addAuthor();
        }
    },
}
</script>

<style scoped>

</style>
